import React from "react";

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    if (
      message &&
      String(message.toLowerCase()).toLowerCase()
      // .match(
      //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // )
    ) {
      actions.question();
    } else if (
      children.props.state.messages[children.props.state.messages.length - 1]
        .numberNext
    ) {
      //   actions.askForDescription();
    } else if (
      children.props.state.messages[children.props.state.messages.length - 1]
        .descriptionNext
    ) {
      // actions.successMessage(message);
      actions.contactUs();
    }
    // else if (message) {
    //     actions.successMessage(message);
    // }
    else {
      actions.reset();
    }
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;
